Vue.component('price-map-filter',{
    props: {
        data: {
            type: Array,
            default: []
        },
        currency: {
            type: String,
            default: '',
        }
    },
    data: function () {
        return{
            message: {
                domestic: FmtMessage.getMessage('js.flight.only.domestic') ? FmtMessage.getMessage('js.flight.only.domestic') : 'js.flight.only.domestic',
                international: FmtMessage.getMessage('js.flight.only.international') ? FmtMessage.getMessage('js.flight.only.international') : 'js.flight.only.international',
                nonstop: FmtMessage.getMessage('js.search.filter.nonstop') ? FmtMessage.getMessage('js.search.filter.nonstop') : 'js.search.filter.nonstop',
                stop1: FmtMessage.getMessage('js.search.filter.1stop') ? FmtMessage.getMessage('js.search.filter.1stop') : 'js.search.filter.1stop',
                stop2: FmtMessage.getMessage('js.search.filter.2stop') ? FmtMessage.getMessage('js.search.filter.2stop') : 'js.search.filter.2stop',
            },
            filter: {
                nonstop: true,
                stop1: true,
                stop2: true,
                domestic: true,
                international: true,
                price: {
                    min: 0,
                    max: 0
                },
            },

            priceRangeFilter:{
                min: 0,
                max: 0
            },
        }

    },
    mounted: function () {
    	var vm=this;
    	$('.nonstop').iCheck({
	        checkboxClass: 'icheckbox_flat-orange '
	      }).on('ifChanged',function(event){
	    	  vm.filter.nonstop=!vm.filter.nonstop;
	      });
    	$('.stop1').iCheck({
	        checkboxClass: 'icheckbox_flat-yellow '
	      }).on('ifChanged',function(event){
	    	  vm.filter.stop1=!vm.filter.stop1;
	      });
    	$('.stop2').iCheck({
	        checkboxClass: 'icheckbox_flat-red '
	      }).on('ifChanged',function(event){
	    	  vm.filter.stop2=!vm.filter.stop2;
	      });	
    	$('.international').iCheck({
	        checkboxClass: 'icheckbox_flat-blue '
	      }).on('ifChanged',function(event){
	    	  vm.filter.international=!vm.filter.international;
	      });
    	$('.domestic').iCheck({
	        checkboxClass: 'icheckbox_flat-blue '
	      }).on('ifChanged',function(event){
	    	  vm.filter.domestic=!vm.filter.domestic;
	      });
    },
    methods: {
        resetFilters: function(){
            this.filter = {
                nonstop: true,
                    stop1: true,
                    stop2: true,
                    domestic: true,
                    international: true,
                    price: {
                    min: 0,
                        max: 0
                }
            };
        },
        setPriceRangeFilterMaxMinVal: function(){

            var prices = this.data.map(function (flight) {
                return flight.amount;
            });

            var max = Math.max.apply(Math, prices) + 1;
            var min =  Math.min.apply(Math, prices);

            max =  parseInt(max);
            min = parseInt(min);

            if (max && min) {
                this.priceRangeFilter.max = max;
                this.priceRangeFilter.min = min;
                this.filter.price.max = max;
                this.filter.price.min = min;
            }
        },
        filterByStop: function (data) {
            var vm = this;
            return data.filter(function (flight) {
                return (vm.filter.nonstop && flight.legCount == 1) || (vm.filter.stop1 && flight.legCount == 2) || (vm.filter.stop2 && flight.legCount > 2)
            })
            return data;
        },
        filterByDomestic: function (data) {
            var vm = this;
            return data.filter(function (flight) {
                return (vm.filter.international && !flight.domestic) || (vm.filter.domestic && flight.domestic);
            })
        },
        filterByPrice: function(data){
            var vm = this;
            return data.filter(function(flight){
                return vm.filter.price.min < flight.amount && vm.filter.price.max > flight.amount;
            });
        },
        applyFilters: function(){
            var minPrices = [];
            minPrices = this.filterByPrice(this.data);
            minPrices = this.filterByDomestic(minPrices);
            minPrices = this.filterByStop(minPrices);
            this.$emit('input', minPrices)
        }
    }

    ,
    computed: {
        filterPricePlaceholder: function () {
            return this.filter.price.min + ' ' + this.currency + ' - ' + this.filter.price.max + ' ' + this.currency;
        }
    },
    watch: {
      data: {
          deep: true,
          handler: function () {
              this.resetFilters();
              this.setPriceRangeFilterMaxMinVal();
          }
      },
      filter: {
          deep: true,
          handler: function () {
              this.applyFilters();
          }
      }          
    },
    template:'\
        <div class="price-map-filter">\
            <div class="price-range">\
                <div class="fmap-price-filter">\                \
                    <p><input type="text"  :value="filterPricePlaceholder" readonly/></p>\
                 </div>\
                 <range-slider v-model="filter.price" class="filterSlider" :min-value="priceRangeFilter.min" :max-value="priceRangeFilter.max" :value-one="filter.price.min" :value-two="filter.price.max" ref="priceSlider"></range-slider>\
            </div>\
            <div class="fmap-stops-filter">\
                <ul class="flight-stops">\
                    <li><label><input v-model="filter.nonstop" class="dTransferCount nonstop" type="checkbox" /> {{message.nonstop}}</label></li>\
                    <li><label><input v-model="filter.stop1" class="dTransferCount stop1" type="checkbox" /> {{message.stop1}}</label></li>\
                    <li><label><input v-model="filter.stop2" class="dTransferCount stop2" type="checkbox" /> {{message.stop2}}</label></li>\
                </ul>\
            </div>\
            <div class="fmap-country-filter">\
                <ul class="flight-domestic">\
                    <li><label><input v-model="filter.domestic" class="domestic" type="checkbox" /> {{message.domestic}}</label></li>\
                    <li><label><input v-model="filter.international" class="international" type="checkbox" /> {{message.international}}</label></li>\
                </ul>\
          </div>\
        </div>'
});
